<template>
    <NodeViewWrapper class="ai-node-wrapper absolute">
        <div class="ai-box p-3 border rounded-md bg-gray-800 text-white">
            <textarea v-model="content" placeholder="Ask AI..." class="w-full bg-gray-700 p-2 rounded"></textarea>

            <button @click="generate" class="mt-2 px-3 py-1 bg-purple-600 rounded hover:bg-purple-500">
                Generate AI
            </button>

            <div v-if="result" class="mt-2 p-2 bg-gray-900 rounded">{{ result }}</div>
        </div>
    </NodeViewWrapper>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { generateAIHelper } from "../../Helpers/composables/aiHelper";
import { NodeViewWrapper, NodeViewProps } from "@tiptap/vue-3";

const props = defineProps();

// Initialize content from node attrs
const content = ref(props.node.attrs.content || "");
const result = ref("");

// Whenever content changes, update the node attribute
watch(content, (val) => {
    props.updateAttributes({ content: val });
});

const generate = async () => {
    const res = await generateAIHelper(content.value, "AI Assistant:");
    if (res.success) result.value = res.text;
};
</script>
